fragment ProspectorSavedFilterFragment on SavedFilter {
    id
    name
    filterString
    htmlUrl
    createdTime
    filterString
    creatorUser {
        id
        name
    }
}
